import axios from "axios";
import {isDevMode} from "@/utils";
//use language learning...android-key
const GOOGLE_URL = "https://vision.googleapis.com/v1/images:annotate?key=AIzaSyCtk5Pq5J24aKH1t19mwS2DosymYlmmKdk";
export const detectText = (szImageBase64:string)=>{
    var data = {
        requests:[
            {
                image:{
                    content:szImageBase64
                },
                features:[
                    {
                        type:'TEXT_DETECTION',
                        maxResults:1
                    }
                ]
            }
        ]
    }
    const request = axios.create({
        // API 请求的默认前缀
        baseURL: isDevMode()?import.meta.env.VITE_DEV_HTTP_BASE_URL:import.meta.env.VITE_HTTP_BASE_URL,
        timeout: 180000 // 请求超时时间,
    })
    return new Promise((resolve, reject) => {
        request({url:GOOGLE_URL, method:'post', data:data}).then(res=>{
            console.log(res);
            const arrayResponses = res.data.responses;
            if (arrayResponses && arrayResponses.length > 0){
                const response0 = arrayResponses[0];
                resolve(response0.fullTextAnnotation?.text);
            }else{
                reject();
            }
        });
    })

}